<template>
    <div class="w-100">
        <div class="d-flex px-3 align-items-center">
            <div class="flex-shrink-1">
                <i :class="'fc fc-' + model.provider"></i>
            </div>
            <div class="flex-grow-1">
                <small>{{ model.provider }}</small>
            </div>
        </div>

        <b-row class="no-gutters w-100">
            <b-col md="12" class="px-3 align-self-center">
                <b-link :href="model.url" target="_blank">{{ model.name }}</b-link>
            </b-col>
            <b-col xs="6" class="px-3 align-self-center">
                <span>ASIN:{{ model.data.asin }}</span>
                <br>
                <span>SKU:{{ model.data.sellerSku }}</span>
            </b-col>
            <b-col xs="6" class="px-3 align-self-center text-right">
                <b-form-checkbox v-model="model.synced" switch @change="onChange">
                </b-form-checkbox>
                <span>x{{ model.quantity }}</span>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    components: {
    },
    props: {
        model: {
            type: Object,
            required: true,
            default() {
                return {}
            },
        },
        toggleSyncedSwitch: {
            type: [ Function, Boolean, ],
            required: false,
            default: true,
        },
    },
    data() {
        return {}
    },
    computed: {
        ...mapGetters([
            'auth_level',
            'trans',
        ])
    },
    async mounted() {},
    methods: {
        onChange() {
            if (typeof this.toggleSyncedSwitch === 'function') {
                this.toggleSyncedSwitch(this.model)
            }
        },
    },
}
</script>

<style lang="scss" scoped></style>

